export class DadosPaginacao {

    size: number;
    page: number;

    constructor(tamanhoPagina: number, indicePagina: number) {
      this.size = tamanhoPagina;
      this.page = indicePagina;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/paginacao/dadosPaginacao.ts